import { useState, cloneElement } from 'react'
import { HiChevronUpDown, HiChevronDown } from 'react-icons/hi2'
import { useIntl } from 'react-intl'
import { ChartEvaluation } from './chart'

import { DropBox } from './DropBox'
import { StarAvaliation } from '../Employee/StarAvaliation/StarAvaliation'
import { EvaluationsStars } from './EvaluationStars'

import { evaluation360 } from '../../i18n/translatedMessages'
import { translate } from '../../i18n/Library/evaluations'

const average = (boss, peer, team) => {
	const values = [boss, peer, team].filter(value => value > 0)

	if (values.length > 0) {
		return (values.reduce((sum, value) => sum + value, 0) / values.length).toFixed(2)
	}

	return 0
}

export function ListEmployee({ employees, template }) {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const [openIndex, setOpenIndex] = useState(null)

	const handleAccordionClick = async (index, id) => {
		setOpenIndex(prevIndex => (prevIndex === index ? null : index))
	}

	return (
		<div className='tw-p-0 tw-m-0 tw-list-none border tw-rounded-md tw-overflow-hidden'>
			<div className='tw-bg-black tw-text-white tw-grid tw-grid-cols-6 tw-justify-between tw-py-2 tw-px-4'>
				<div className='tw-flex tw-gap-2 tw-items-center'>
					{evaluation360.titleEmployeeAndJob}
					<HiChevronUpDown />
				</div>
				<div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
					{evaluation360.titleSelfAssessment}
					<HiChevronUpDown />
				</div>
				<div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
					{evaluation360.titleBoss}
					<HiChevronUpDown />
				</div>
				<div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
					{evaluation360.titlePairs}
					<HiChevronUpDown />
				</div>
				<div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
					{evaluation360.titleTeam}
					<HiChevronUpDown />
				</div>
				<div className='tw-flex tw-gap-2 tw-items-center'>
					{evaluation360.titleAverage}
					<HiChevronUpDown />
				</div>
			</div>
			{[...employees]
				.sort((a, b) => a.targetName.localeCompare(b.targetName))
				.map((employee, index) => {
					const { autoResult, bossResult, peerResult, teamResult } = employee.generalResults
					return (
						<AccordionItem
							key={employee.targetId}
							employee={employee}
							isOpen={index === openIndex}
							setIsOpen={() => handleAccordionClick(index, employee.targetEmployeeId)}
						>
							<>
								<DropBox title={evaluation360.titleSelfAssessment} stars={autoResult}>
									<div>
										{employee?.autoResults.length !== 0 ? (
											[...employee?.autoResults]
												.sort((a, b) => a.criteriaName.localeCompare(b.criteriaName))
												.map(item => (
													<div key={item.criteriaId} className='tw-flex tw-justify-between tw-items-center tw-gap-4 border-bottom tw-my-3 tw-py-3'>
														<div className='tw-w-40 tw-text-sm tw-flex-none'>{translate[language][item.criteriaName] || item.criteriaName}</div>
														<div className='tw-w-full tw-text-sm'>{translate[language][item.criteriaDesc] || item.criteriaDesc}</div>
														<div className='tw-w-[355px] tw-flex-none'>
															<EvaluationsStars stars={item.evaluation} />
														</div>
													</div>
												))
										) : (
											<div className='tw-bg-gray-200 tw-text-gray-400 tw-text-center tw-rounded-md tw-p-2'>
												{' '}
												{evaluation360.unregisteredAssessment}
											</div>
										)}
									</div>
								</DropBox>
								<DropBox title={evaluation360.titleBoss} stars={bossResult}>
									<div>
										{employee?.bossResults.length !== 0 ? (
											[...employee?.bossResults]
												.sort((a, b) => a.criteriaName.localeCompare(b.criteriaName))
												.map(item => (
													<div key={item.criteriaId} className='tw-flex tw-justify-between tw-items-center tw-gap-4 border-bottom tw-my-3 tw-py-3'>
														<div className='tw-w-40 tw-text-sm tw-flex-none'>{translate[language][item.criteriaName] || item.criteriaName}</div>
														<div className='tw-w-full tw-text-sm'>{translate[language][item.criteriaDesc] || item.criteriaDesc}</div>
														<div className='tw-w-[355px] tw-flex-none'>
															<EvaluationsStars stars={item.evaluation} />
														</div>
													</div>
												))
										) : (
											<div className='tw-bg-gray-200 tw-text-gray-400 tw-text-center tw-rounded-md tw-p-2'>
												{' '}
												{evaluation360.unregisteredAssessment}
											</div>
										)}
									</div>
								</DropBox>
								<DropBox title={evaluation360.titlePairs} stars={peerResult}>
									<div>
										{employee?.peerResults.length !== 0 ? (
											[...employee?.peerResults]
												.sort((a, b) => a.criteriaName.localeCompare(b.criteriaName))
												.map(item => (
													<div key={item.criteriaId} className='tw-flex tw-justify-between tw-items-center tw-gap-4 border-bottom tw-my-3 tw-py-3'>
														<div className='tw-w-40 tw-text-sm tw-flex-none'>{translate[language][item.criteriaName] || item.criteriaName}</div>
														<div className='tw-w-full tw-text-sm'>{translate[language][item.criteriaDesc] || item.criteriaDesc}</div>
														<div className='tw-w-[355px] tw-flex-none'>
															<EvaluationsStars stars={item.evaluation} />
														</div>
													</div>
												))
										) : (
											<div className='tw-bg-gray-200 tw-text-gray-400 tw-text-center tw-rounded-md tw-p-2'>
												{' '}
												{evaluation360.unregisteredAssessment}
											</div>
										)}
									</div>
								</DropBox>
								<DropBox title={evaluation360.titleTeam} stars={teamResult}>
									<div>
										{employee?.teamResults.length !== 0 ? (
											[...employee?.teamResults]
												.sort((a, b) => a.criteriaName.localeCompare(b.criteriaName))
												.map(item => (
													<div key={item.criteriaId} className='tw-flex tw-justify-between tw-items-center tw-gap-4 border-bottom tw-my-3 tw-py-3'>
														<div className='tw-w-40 tw-text-sm tw-flex-none'>{translate[language][item.criteriaName] || item.criteriaName}</div>
														<div className='tw-w-full tw-text-sm'>{translate[language][item.criteriaDesc] || item.criteriaDesc}</div>
														<div className='tw-w-[355px] tw-flex-none'>
															<EvaluationsStars stars={item.evaluation} />
														</div>
													</div>
												))
										) : (
											<div className='tw-bg-gray-200 tw-text-gray-400 tw-text-center tw-rounded-md tw-p-2'>
												{' '}
												{evaluation360.unregisteredAssessment}
											</div>
										)}
									</div>
								</DropBox>
								<DropBox title={evaluation360.titleAverage} stars={average(bossResult, peerResult, teamResult)}>
									<div className='tw-h-[500px] border tw-rounded-md'>
										<ChartEvaluation evaluation={employee} template={template} />
									</div>
								</DropBox>
							</>
						</AccordionItem>
					)
				})}
		</div>
	)
}

const AccordionItem = ({ children, isOpen, setIsOpen, employee }) => {
	const { targetName, targetJob } = employee
	const { autoResult, bossResult, peerResult, teamResult } = employee.generalResults

	console.log('employee do accordion', employee)

	const toggleAccordion = () => {
		setIsOpen(isOpen => !isOpen)
	}

	const clonedChild = cloneElement(children, {})

	return (
		<>
			<div
				onClick={toggleAccordion}
				className={`tw-grid tw-grid-cols-6 tw-justify-between tw-items-center tw-p-4 border-bottom tw-cursor-pointer tw-transition-all ${
					isOpen ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-white'
				} tw-flex tw-justify-between tw-items-center tw-w-full tw-p-4 tw-text-left  tw-font-medium tw-focus:outline-none`}
			>
				<div className='tw-flex tw-items-center tw-gap-4'>
					<img
						src={employee.profileImg ?? 'https://assets.mydna.company/profile-placeholder.png'}
						alt=''
						className='img-fluid rounded-circle tw-w-[64px] tw-h-[64px]'
					/>
					<div>
						<h5 className='tw-m-0 tw-p-0 tw-text-base tw-font-bold'>{targetName}</h5>
						<span>{targetJob.label}</span>
					</div>
				</div>
				<div className='tw-flex tw-justify-center'>
					<StarAvaliation label='Auto Evaluación' value={autoResult} event={isOpen} />
				</div>
				<div className='tw-text-center'>
					<div className={`${isOpen ? 'tw-text-gray-100' : 'tw-text-gray-500'}`}>{evaluation360.titleBoss} </div>
					<div className='tw-font-bold'>{bossResult?.toFixed(1) || '--'}</div>
				</div>
				<div className='tw-text-center'>
					<div className={`${isOpen ? 'tw-text-gray-100' : 'tw-text-gray-500'}`}>{evaluation360.titlePairs} </div>
					<div className='tw-font-bold'>{peerResult?.toFixed(1) || '--'}</div>
				</div>
				<div className='tw-text-center'>
					<div className={`${isOpen ? 'tw-text-gray-100' : 'tw-text-gray-500'}`}>{evaluation360.titleTeam} </div>
					<div className='tw-font-bold'>{teamResult?.toFixed(1) || '--'}</div>
				</div>
				<div className='tw-flex tw-justify-between tw-items-center tw-pr-4'>
					<StarAvaliation label={evaluation360.titleAverage} value={average(bossResult, peerResult, teamResult)} event={isOpen} />
					<div className={`tw-transition-all ${isOpen ? 'tw-rotate-180' : 'tw-rotate-0'}`}>
						<HiChevronDown />
					</div>
				</div>
			</div>
			<div className={`tw-overflow-hidden ${isOpen ? 'tw-max-h-full' : 'tw-max-h-0'}`}>
				<div className='tw-p-4 tw-bg-purple-100 '>{clonedChild}</div>
			</div>
		</>
	)
}
